import { Marketplace } from '../../enums/marketplace.enum';

export class CarrierMarketplaceMappingRequestModel {
  carrierId: number = 0;
  companyId: number = 0;
  marketplace: Marketplace = Marketplace.Unknown;
  shippingName: string = '';
  shippingCode: string = '';
}
